import { useContext } from "react";

import { AuthContext, AuthContextType } from "../contexts/Auth/AuthContext";

/**
 * Hook for accessing global authentication state from AuthContext.
 *
 * This is the primary API for accessing auth state in general app components.
 * The hook provides access to the current user's authentication state, including:
 * - accessToken, role, userId, tenantId, context
 * - login/logout functions
 * - password reset functions
 *
 * For auth-specific components (login forms, etc.), you can use hooks directly from
 * @/features/auth/api for more granular control. For general app components that need
 * to check auth state or trigger auth actions, use this hook.
 */
export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
};
